/** Português (Portuguese) — tertiary language */
const pt = {
  nav: {
    home: "Início",
    findJobs: "Buscar Vagas",
    companies: "Empresas",
    postAJob: "Publicar Vaga",
    signIn: "Entrar",
    getStarted: "Começar",
    dashboard: "Painel",
    profile: "Perfil",
    signOut: "Sair",
    signedInAs: "Conectado como",
  },
  hero: {
    badge: "vagas ativas · empresas contratando",
    h1a: "Encontre trabalho",
    h1b: "perto de você",
    heroSubtitle: "Busque oportunidades por localização, horário e modalidade.",
    purposeLine: "O InfoCityJobs conecta candidatos e empresas: crie seu perfil, prepare seu currículo, busque vagas e candidate-se a novas oportunidades.",
    subtitle: "Conectamos os melhores talentos com as melhores empresas em todos os setores.",
    searchJobs: "Buscar Vagas",
    keywordPlaceholder: "Cargo, habilidades ou empresa",
    locationPlaceholder: "Cidade ou remoto",
    allTypes: "Todos os tipos",
    allLevels: "Todos os níveis",
    popular: "Popular",
    jobsLabel: "Vagas",
    companiesLabel: "Empresas",
    candidatesLabel: "Candidatos",
    useMyLocation: "Usar minha localização",
    forToday: "Para hoje",
    urgentOnly: "Urgentes",
    filtersBtn: "Filtros",
    filterRemote: "Remoto",
    filterPartTime: "Meio período",
    filterNoExperience: "Sem experiência",
    categoriesLabel: "Categorias",
    locating: "Buscando...",
    viewJobsBtn: "Ver vagas",
  },
  sections: {
    featuredLabel: "Top Oportunidades",
    featuredTitle: "Vagas em Destaque",
    recommendedForYouShort: "Recomendadas para você",
    completeProfileForRecs: "Complete seu perfil para melhorar suas recomendações",
    jobCountSingular: "vaga",
    jobCountPlural: "vagas",
    featuredSubtitle: "Oportunidades selecionadas dos melhores empregadores",
    featuredViewAll: "Ver todas",
    mapLabel: "Descoberta Local",
    mapTitle: "Explore vagas no mapa",
    mapSubtitle: "Descubra quais oportunidades existem na sua região.",
    noJobsYet: "Ainda não há vagas disponíveis. Seja o primeiro a publicar!",
    viewAllJobsBtn: "Ver todas as vagas",
    availableJobsLabel: "Vagas recentes",
    availableJobsTitle: "Vagas disponíveis",
    companiesLabel: "Top Empregadores",
    companiesTitle: "Empresas Contratando",
    companiesSubtitle: "Organizações líderes buscando talentos ativamente",
    companiesViewAll: "Ver todas",
    marketLabel: "Dados do Mercado",
    marketTitle: "Inteligência do Mercado de Trabalho",
    marketSubtitle: "Benchmarks salariais, demanda de contratação e tendências por localização em tempo real.",
    employersLabel: "Para Empregadores",
    employersTitle: "Está contratando?",
    employersSubtitle: "Publique vagas e alcance milhares de candidatos qualificados. Contrate mais rápido e de forma mais inteligente.",
    ecosystemLabel: "Rede InfoCity",
    ecosystemTitle: "O Ecossistema InfoCity",
    ecosystemSubtitle: "Um ecossistema. Seis marketplaces especializados.",
    seeAllJobs: "Ver Todas as Vagas",
  },
  market: {
    salaryTitle: "Salário Médio por Setor",
    salarySubtitle: "Anual, USD",
    demandTitle: "Demanda de Contratação",
    demandSubtitle: "Tendências atuais",
    citiesTitle: "Cidades com Mais Contratações",
    citiesSubtitle: "Mercados mais ativos",
    openJobsLabel: "vagas abertas",
    remote: "Posições remotas",
    fullTime: "Vagas de período integral",
    techSector: "Setor de tecnologia",
    entryLevel: "Nível inicial",
    seniorLevel: "Nível sênior",
  },
  employerFeatures: [
    "Publicar vagas ilimitadas",
    "Acesso a mais de 125.000 candidatos verificados",
    "Rastreamento de candidatos integrado (ATS)",
    "Gerenciamento do pipeline de contratação",
    "Análises e relatórios de conversão",
    "Correspondência de candidatos com IA",
  ],
  cta: {
    postJobFree: "Publicar Vaga — É Grátis",
    exploreCompanies: "Explorar Empresas",
    browseJobs: "Buscar Vagas",
    seeAllJobs: "Ver Todas as Vagas",
    youAreHere: "Você está aqui",
    comingSoon: "Em breve",
    exploreNearby: "Explorar vagas perto de mim",
    viewFullMap: "Ver mapa completo",
    postJob: "Publicar Vaga",
  },
  jobCard: {
    today: "Hoje",
    yesterday: "Ontem",
    dAgo: "d atrás",
    wAgo: "sem atrás",
    moAgo: "meses atrás",
    applicants: "candidatos",
    remote: "Remoto",
    upTo: "Até",
    perYear: "/ano",
    perHour: "/hora",
    perMonth: "/mês",
    hybrid: "Híbrido",
    match: "compatível",
    salaryNotSpecified: "Salário não especificado",
    typeFullTime: "Tempo integral",
    typePartTime: "Meio período",
    typeContract: "Contrato",
    typeTemporary: "Temporário",
    typeFreelance: "Freelance / Por projeto",
    typeInternship: "Estágio",
    typeHourly: "Por hora",
    typeSeasonal: "Sazonal",
    typeOther: "Outro",
    expNoExperience: "Sem experiência",
    expEntry: "Iniciante / Entry level",
    expJunior: "Junior",
    expMid: "Intermediário",
    expSenior: "Senior",
    expLead: "Lead / Líder",
    expManager: "Manager / Gerência",
    expDirector: "Diretor",
    expExecutive: "Executivo",
    expOther: "Outro",
    shareAria: "Compartilhar vaga",
  },
  map: {
    searchThisArea: "Buscar nesta área",
    yourLocation: "Sua localização atual",
    viewJob: "Ver vaga",
    noJobsInArea: "Nenhuma vaga com localização nesta área",
    mapUnavailable: "Mapa indisponível no momento",
    jobsAtLocation: "vagas neste ponto",
  },
  jobsPage: {
    cityPlaceholder: "Cidade...",
    listView: "Lista",
    mapView: "Mapa",
    radiusLabel: "Raio",
    nearMeBadge: "Perto de mim",
    exitNearMe: "Saír",
    geoErrorBanner: "Não conseguimos obter sua localização. Busque manualmente por cidade.",
    dismiss: "Fechar",
    jobsSuffix: "vagas",
    clear: "Limpar",
    showAll: "Ver todas",
    showLess: "Ver menos",
    quickToday: "Hoje",
    quickUrgent: "Urgente",
    quickRemote: "Remoto",
    quickPartTime: "Meio período",
    quickNoExp: "Sem exp.",
    backToAllJobs: "Todas as vagas",
    quickFiltersLabel: "Filtros rápidos",
    sectorLabel: "Setor",
    jobTypeLabel: "Tipo de vaga",
    workModeLabel: "Modalidade",
    experienceLabel: "Experiência",
    datePostedLabel: "Publicado",
    sortLabel: "Ordenar",
    anyOption: "Qualquer",
    anyTime: "Qualquer momento",
    salaryLabel: "Salário",
    salaryMinPlaceholder: "Mín",
    salaryMaxPlaceholder: "Máx",
    prevPage: "Anterior",
    nextPage: "Próxima",
    dateToday: "Hoje",
    date3days: "Últimos 3 dias",
    date7days: "Última semana",
    date30days: "Último mês",
    sortNewest: "Mais recente",
    sortSalary: "Maior salário",
    sortApplicants: "Mais candidatos",
    categoryTech: "Tecnologia",
    categoryFinance: "Finanças",
    categoryHospitality: "Hotelaria",
    categoryHealthcare: "Saúde",
    categoryMarketing: "Marketing",
    categoryEducation: "Educação",
    categoryDesign: "Design",
    categoryLogistics: "Logística",
    workModeRemote: "Remoto",
    workModeHybrid: "Híbrido",
    workModeOnsite: "Presencial",
    locationLabel: "Localização",
    contractTypeLabel: "Tipo de contrato",
    quickNearMe: "Perto de mim",
    geoRequesting: "Localizando...",
    geoErrorDenied: "Permissão de localização negada. Busque manualmente por cidade.",
    noJobsInRadiusTitle: "Nenhuma vaga neste raio",
    noJobsInRadiusDesc: "Não encontramos vagas a {radius} km da sua localização. Tente ampliar o raio.",
  },
  filters: {
    title: "Filtros",
    clearAll: "Limpar tudo",
    applyFilters: "Aplicar Filtros",
    keyword: "Buscar vagas",
    location: "Cidade ou remoto",
    category: "Categoria",
    jobType: "Tipo de vaga",
    experience: "Experiência",
    workMode: "Modalidade",
    allCategories: "Todas as categorias",
    allTypes: "Todos os tipos",
    allLevels: "Todos os níveis",
    anyMode: "Qualquer",
    remoteOnly: "Apenas remoto",
    onsiteOnly: "Apenas presencial",
    found: "vagas encontradas",
    noJobs: "Nenhuma vaga encontrada",
    noJobsDesc: "Tente ajustar os termos de busca ou filtros",
    clearFilters: "Limpar filtros",
    searching: "Buscando...",
    search: "Buscar",
    remote: "Remoto",
    jobListings: "Lista de Vagas",
    findJobs: "Buscar Vagas",
  },
  jobDetail: {
    back: "Voltar às vagas",
    applyNow: "Candidatar-se",
    applyExternally: "Candidatar Externamente",
    urgentBadge: "URGENTE",
    todayBadge: "HOJE",
    immediateBadge: "INÍCIO IMEDIATO",
    remoteFromLabel: "Disponível a partir de",
    shiftLabel: "Turno",
    alreadyApplied: "Já se Candidatou",
    signInToApply: "Entre para se Candidatar",
    description: "Descrição da Vaga",
    requirements: "Requisitos",
    benefits: "Benefícios",
    aboutRole: "Sobre a Vaga",
    whatWeNeed: "O que buscamos",
    perksLabel: "Benefícios e Vantagens",
    interested: "Interessado?",
    applyDesc: "Candidate-se em 2 minutos. Não precisa de conta para começar.",
    jobDetails: "Detalhes da Vaga",
    companyLabel: "Empresa",
    jobTypeLabel: "Tipo de Vaga",
    categoryLabel: "Categoria",
    experienceLabel: "Experiência",
    locationLabel: "Localização",
    postedLabel: "Publicado",
    applicantsLabel: "Candidatos",
    viewCompanyProfile: "Ver perfil da empresa",
    people: "pessoas",
    jobClosedTitle: "Esta vaga não aceita mais candidaturas",
    jobClosedDesc: "A empresa fechou ou pausou este anúncio.",
    shareAria: "Compartilhar vaga",
    reportJob: "Reportar vaga",
    reportTitle: "Reportar esta vaga",
    reportReasons: {
      possible_fraud: "Possível fraude",
      false_info: "Informação falsa",
      discrimination: "Discriminação",
      inappropriate_content: "Conteúdo inapropriado",
      job_expired: "Vaga vencida",
      other: "Outro motivo",
    },
    reportDetailsPlaceholder: "Conte-nos mais (opcional)",
    reportSubmit: "Enviar denúncia",
    reportSent: "Obrigado, recebemos sua denúncia. Nossa equipe vai revisar.",
    reportError: "Não conseguimos enviar a denúncia. Tente novamente.",
    jobNotFound: "Não encontramos esta vaga",
    backToJobs: "Voltar para empregos",
    viewOfferExternal: "Ver vaga / Candidatar-se no site externo",
    descriptionPreview: "Resumo da vaga",
    descriptionPreviewCaption: "Resumo fornecido pela Adzuna. Para ver os detalhes completos, candidate-se no site original.",
    scheduleLabel: "Jornada",
    scheduleFullTime: "Tempo integral",
    schedulePartTime: "Meio período",
    contractPermanent: "Contrato efetivo",
    contractTemporary: "Contrato temporário",
  },

  jobMatch: {
    cardTitle: "Compatibilidade com seu CV",
    compatible: "compatível",
    basedOnCv: "Calculado com seu CV real",
    viewAnalysis: "Ver análise",
    noCvTitle: "Descubra sua compatibilidade",
    noCvDesc: "Crie ou envie seu CV para conhecer sua compatibilidade com esta vaga.",
    createCvCta: "Criar meu CV",
    modalTitle: "Análise de compatibilidade",
    matchesTitle: "Coincidências",
    gapsTitle: "Faltantes",
    strengthsTitle: "Pontos fortes",
    recoTitle: "Recomendações",
    strengthSkills: "Você tem {count} habilidades que esta vaga solicita",
    strengthExperience: "Seu nível de experiência é ideal para esta vaga",
    strengthRemote: "A modalidade remota desta vaga é totalmente compatível com seu perfil",
    strengthLocation: "Sua localização coincide com a da vaga",
    strengthAllReqs: "Seu CV reflete todos os requisitos indicados",
    strengthRelevantExp: "Sua experiência como {position} é relevante para esta vaga",
    recoKeywords: "Se você realmente tem experiência em {list}, considere adicioná-la ao seu CV",
    recoRequirements: "A vaga pede: \"{req}\" — verifique se seu CV reflete isso",
    recoExperience: "Esta vaga busca um perfil de nível {level}; destaque no seu CV a experiência real mais próxima desse nível",
    recoHighlight: "Destaque sua experiência em {skill} pois é muito relevante para esta vaga",
    recoRelocate: "Esta vaga é presencial e não coincide com sua localização; mencione sua disponibilidade para se mudar, se aplicável",
    strengthWorkMode: "Sua modalidade de trabalho preferida coincide com a desta vaga",
    recoWorkMode: "Esta vaga não coincide com sua modalidade de trabalho preferida; revise suas preferências no seu Perfil Profissional",
    strengthSalary: "A faixa salarial desta vaga cobre sua expectativa salarial",
    recoSalaryBelow: "A faixa salarial desta vaga está abaixo da sua expectativa; veja se ainda assim te interessa",
    recoAvailability: "Você não informou sua disponibilidade; adicione-a no seu Perfil Profissional para que as empresas vejam",
    recoLocationUnknown: "Localização não avaliada por falta de informação.",
    adaptCvCta: "Adaptar meu CV para esta vaga",
    evaluatedNote: "Calculado sobre {max}/100 pontos avaliáveis com base nos dados desta vaga",
    employer: {
      strengthSkills: "{name} tem {count} habilidades que esta vaga solicita",
      strengthExperience: "O nível de experiência de {name} é ideal para esta vaga",
      strengthRemote: "A modalidade remota desta vaga é totalmente compatível com o perfil de {name}",
      strengthLocation: "A localização de {name} coincide com a da vaga",
      strengthAllReqs: "O CV de {name} reflete todos os requisitos indicados",
      strengthRelevantExp: "A experiência de {name} como {position} é relevante para esta vaga",
      recoKeywords: "Se {name} realmente tem experiência em {list}, sugira adicioná-la ao CV",
      recoRequirements: "A vaga pede: \"{req}\" — verifique se o CV de {name} reflete isso",
      recoExperience: "Esta vaga busca um perfil de nível {level}; verifique se {name} destaca no CV a experiência real mais próxima desse nível",
      recoHighlight: "{name} poderia destacar sua experiência em {skill} pois é muito relevante para esta vaga",
      recoRelocate: "Esta vaga é presencial e não coincide com a localização de {name}; verifique sua disponibilidade para se mudar",
      strengthWorkMode: "A modalidade de trabalho preferida de {name} coincide com a desta vaga",
      recoWorkMode: "Esta vaga não coincide com a modalidade de trabalho preferida de {name}",
      strengthSalary: "A faixa salarial desta vaga cobre a expectativa salarial de {name}",
      recoSalaryBelow: "A faixa salarial desta vaga está abaixo da expectativa de {name}",
      recoAvailability: "{name} não informou sua disponibilidade no Perfil Profissional",
      recoLocationUnknown: "Localização não avaliada por falta de informação.",
    },
  },
  cvAdapt: {
    modalTitle: "Adaptar meu CV para esta vaga",
    generating: "Gerando seu CV adaptado com IA...",
    errorMsg: "Não foi possível gerar a adaptação. Tente novamente em breve.",
    close: "Fechar",
    forJob: "Para a vaga de",
    summaryTitle: "Resumo profissional",
    original: "Original",
    adapted: "Adaptado",
    skillsTitle: "Habilidades (reordenadas)",
    experienceTitle: "Experiência (reordenada)",
    suggestionsTitle: "Sugestões — não incluídas no seu CV",
    suggestionsHint: "Esta vaga menciona estas habilidades. Adicione-as ao seu CV apenas se você realmente tiver experiência com elas.",
    versionNameLabel: "Nome desta versão",
    defaultVersionPrefix: "CV adaptado para",
    discard: "Descartar",
    saveVersion: "Salvar como nova versão",
    savedTitle: "Versão salva!",
    downloadPdf: "Baixar PDF",
  },
  cvVersions: {
    title: "Minhas versões de CV",
    empty: "Você ainda não adaptou seu CV para nenhuma vaga.",
    adaptedBadge: "Adaptado",
    view: "Ver",
    downloadPdf: "Baixar PDF",
    delete: "Excluir",
    deleteConfirm: "Excluir esta versão de CV?",
  },
  apply: {
    title: "Candidatar-se à Vaga",
    at: "em",
    fullName: "Nome Completo",
    email: "E-mail",
    phone: "Telefone",
    linkedin: "LinkedIn (opcional)",
    uploadCv: "Enviar Currículo",
    uploadCvHint: "Clique para enviar PDF, DOC, DOCX",
    coverLetter: "Carta de Apresentação",
    coverLetterPlaceholder: "Por que você é o candidato ideal para esta vaga?",
    submit: "Enviar Candidatura",
    successTitle: "Candidatura Enviada!",
    successMsg1: "Boa sorte! A equipe da",
    successMsg2: "entrará em contato.",
    continue: "Continuar Buscando",
    close: "Fechar",
    applyPosition: "Candidatar-se à Vaga",
  },
  companies: {
    header: "Empresas",
    subtitle: "Encontre empresas que estão contratando.",
    searchPlaceholder: "Buscar empresas...",
    cityPlaceholder: "Cidade",
    allIndustries: "Todos os setores",
    found: "empresa(s) encontrada(s)",
    noResults: "Nenhuma empresa encontrada",
    noResultsDesc: "Tente um termo de busca diferente",
    openRoles: "vaga(s) aberta(s)",
    search: "Buscar",
    chipTech: "Tecnologia",
    chipHospitality: "Hotelaria",
    chipHealth: "Saúde",
    chipFinance: "Finanças",
    chipEducation: "Educação",
    chipRemote: "Remoto",
    filters: "Filtros",
    clearAll: "Limpar",
    pageIndicator: "Página {page} de {total}",
    prevPage: "Página anterior",
    nextPage: "Próxima página",
    loading: "Carregando...",
    filterPanelTitle: "Filtrar Empresas",
    countryLabel: "País",
    allCountries: "Todos os países",
    regionLabel: "Região / Estado",
    allRegions: "Todas as regiões",
    industryLabel: "Setor",
    sizeLabel: "Tamanho da Empresa",
    anySize: "Qualquer tamanho",
    minJobsLabel: "Mín. Vagas Abertas",
    minJobsPlaceholder: "ex. 3",
    applyFilters: "Aplicar Filtros",
    sortMostJobs: "Mais vagas abertas",
    sortNewest: "Empresas mais novas",
    sortAZ: "A–Z",
    sizeStartup: "Startup (1–10)",
    sizeSmall: "Pequena (11–50)",
    sizeMedium: "Média (51–200)",
    sizeEnterprise: "Corporativa (1000+)",
    size_1_10: "Startup (1–10)",
    size_11_50: "Pequena (11–50)",
    size_51_200: "Média (51–200)",
    size_201_500: "Média-grande (201–500)",
    size_501_1000: "Grande (501–1.000)",
    size_1000_plus: "Corporativa (+1.000)",
    countryNames: {
      unitedStates: "Estados Unidos", spain: "Espanha", portugal: "Portugal", mexico: "México",
      argentina: "Argentina", colombia: "Colômbia", brazil: "Brasil", unitedKingdom: "Reino Unido",
      france: "França", germany: "Alemanha", canada: "Canadá", uruguay: "Uruguai",
    },
    industryNames: {
      technology: "Tecnologia", finance: "Finanças", healthcare: "Saúde", marketing: "Marketing",
      education: "Educação", legal: "Jurídico", operations: "Operações", engineering: "Engenharia",
      retail: "Varejo", media: "Mídia", realEstate: "Imóveis", hospitality: "Hotelaria",
    },
  },
  companyProfile: {
    back: "Voltar às empresas",
    opportunities: "Oportunidades",
    openPositions: "Vagas Abertas",
    about: "Sobre",
    companyInfo: "Informações da Empresa",
    industryLabel: "Setor",
    sizeLabel: "Tamanho",
    hqLabel: "Sede",
    getDirections: "Como chegar",
    activeJobsLabel: "Vagas Ativas",
    visitWebsite: "Visitar Site",
    lookingForJob: "Buscando emprego?",
    browseAll: "Ver todas as vagas",
    employees: "funcionários",
    openRolesLabel: "Vagas Abertas",
    teamSize: "Tamanho da Equipe",
    locationLabel: "Localização",
    noJobs: "Sem vagas abertas no momento",
    noJobsDesc: "Volte em breve ou explore outras empresas",
    websiteLabel: "Site",
    companyFallback: "Empresa",
    browseAllDesc: "Explore as {count} vagas abertas na {name}.",
    foundedLabel: "Fundada em",
    benefitsLabel: "Benefícios",
    cultureLabel: "Cultura e ambiente",
  },
  auth: {
    signIn: "Entrar",
    register: "Registrar",
    emailLabel: "E-mail",
    passwordLabel: "Senha",
    fullNameLabel: "Nome Completo",
    jobSeeker: "Candidato",
    employer: "Empregador",
    continueGoogle: "Continuar com Google",
    orEmail: "ou continue com e-mail",
    createAccount: "Criar Conta",
    alreadyHave: "Já tem uma conta?",
    noAccount: "Não tem uma conta?",
    welcomeBack: "Bem-vindo! Entre para continuar.",
    joinUs: "Crie sua conta e comece sua jornada.",
    iAm: "Sou:",
    cancel: "Cancelar",
    signInAs: "Entrar como:",
    signInCandidate: "Candidato / Buscador de Emprego",
    signInEmployer: "Empregador / Empresa",
    namePlaceholder: "João Silva",
    emailPlaceholder: "seu@email.com",
    passwordPlaceholder: "••••••••",
    passwordMinLength: "Mínimo 8 caracteres",
    acceptTermsPrefix: "Eu aceito os",
    acceptTermsAnd: "e a",
    termsOfService: "Termos de Serviço",
    privacyPolicy: "Política de Privacidade",
    marketingOptIn: "Quero receber novidades e oportunidades do InfoCityJobs",
    forgotPassword: "Esqueceu sua senha?",
    forgotPasswordSubtitle: "Digite seu e-mail e enviaremos um link para redefini-la.",
    sendResetLink: "Enviar instruções",
    resetEmailSent: "Se existir uma conta associada a esse e-mail, você receberá instruções para redefinir sua senha.",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar senha",
    resetPassword: "Redefinir senha",
    passwordUpdated: "Sua senha foi atualizada com sucesso.",
    invalidToken: "Este link é inválido ou já foi utilizado.",
    expiredToken: "Este link expirou. Solicite um novo.",
    passwordMismatch: "As senhas não coincidem.",
    passwordTooShort: "A senha deve ter pelo menos 8 caracteres.",
    backToLogin: "Voltar para o login",
    requestNewLink: "Solicitar um novo link",
    goToLogin: "Entrar",
  },
  userDash: {
    welcome: "Bem-vindo de volta",
    applications: "Candidaturas",
    savedJobs: "Vagas Salvas",
    profile: "Perfil",
    editProfile: "Editar",
    noApplications: "Sem candidaturas ainda",
    noApplicationsDesc: "Comece a se candidatar às vagas que te interessam",
    browseJobs: "Buscar Vagas",
    noSavedJobs: "Sem vagas salvas",
    noSavedJobsDesc: "Salve vagas para revisá-las mais tarde",
    findJobs: "Encontrar Vagas",
    myApplications: "Minhas Candidaturas",
    applied: "Candidatado",
    saveChanges: "Salvar Alterações",
    cancel: "Cancelar",
    fullNameLabel: "Nome Completo",
    phoneLabel: "Telefone",
    locationLabel: "Localização",
    linkedinLabel: "LinkedIn",
    bioLabel: "Sobre mim",
    bioPlaceholder: "Conte aos empregadores sobre você...",
    memberSince: "Membro desde",
    stats: "estatísticas",
    savedLabel: "salvas",
    newMatches: "Novos Matches",
    recommendedTitle: "Vagas Recomendadas para Você",
    createCvBetterMatches: "Criar CV para melhores matches",
    unlockTitle: "Desbloqueie o Matching com IA",
    unlockDesc: "Crie seu CV para receber recomendações de vagas personalizadas com até 99% de compatibilidade.",
    getStarted: "Começar",
    noRecsTitle: "Ainda sem recomendações",
    noRecsDesc: "Adicione um CV para receber recomendações de vagas personalizadas",
    editCV: "Editar CV",
    createCV: "Criar CV",
    noCvYetTitle: "Sem CV ainda",
    noCvYetDesc: "Crie um CV profissional com ajuda da IA",
    createCvWithAI: "Criar CV com IA",
    positionsSuffix: "cargos",
    listedSuffix: "listadas",
    lastUpdated: "Última atualização",
    topSkills: "Principais Habilidades",
    networkLabel: "Rede InfoCity",
    percentComplete: "completo",
    addMoreInfo: "— adicione mais informações para melhorar sua visibilidade",
    newJobSingular: "nova vaga",
    newJobPlural: "novas vagas",
    matchProfileDesc: "compatível(is) com seu perfil (80%+)",
    viewOffer: "Ver oferta",
    offerBanner_pending: "Oferta recebida",
    offerBanner_accepted: "Oferta aceita",
    offerBanner_rejected: "Oferta rejeitada",
    offerBanner_withdrawn: "Oferta retirada",
  },
  stages: {
    new_applicant: "Candidatado",
    contacted: "Contactado",
    interview: "Entrevista",
    offer: "Oferta",
    hired: "Contratado",
    rejected: "Rejeitado",
  },
  companyDash: {
    employerDash: "Painel do Empregador",
    overview: "Visão Geral",
    exploreNearby: "Explorar vagas perto de mim",
    postJob: "Publicar Vaga",
    myListings: "Minhas Vagas",
    applicants: "Candidatos",
    companyProfile: "Perfil da Empresa",
    activeJobs: "Vagas Ativas",
    totalApplications: "Candidaturas",
    interviews: "Entrevistas",
    hired: "Contratados",
    recruitmentFunnel: "Funil de Recrutamento",
    hiringPipeline: "Pipeline de Contratação",
    listings: "Anúncios",
    viewAll: "Ver todos",
    recentActivity: "Atividade Recente",
    latestApps: "Últimas Candidaturas",
    noJobs: "Sem vagas publicadas",
    noJobsDesc: "Publique sua primeira vaga para começar a receber candidatos",
    postFirstJob: "Publicar Primeira Vaga",
    noApplicants: "Sem candidatos ainda",
    noApplicantsDesc: "As candidaturas aparecerão aqui quando os candidatos se inscreverem",
    management: "Gestão",
    newListing: "Novo Anúncio",
    publishJob: "Publicar Anúncio de Vaga",
    editProfile: "Editar Perfil",
    saveProfile: "Salvar Perfil",
    keepUpToDate: "Mantenha seu perfil atualizado para atrair melhores candidatos.",
    newJob: "Nova Vaga",
    applicantsCount: "candidatos",
    viewsCount: "visualizações",
    postedOn: "Publicado",
    closeJobConfirm: "Fechar este anúncio?",
    settings: "Configurações",
    viewJob: "Ver vaga",
  },
  postJobForm: {
    titleLabel: "Título da Vaga",
    titlePlaceholder: "ex. Desenvolvedor Sênior de Software",
    locationLabel: "Localização",
    locationPlaceholder: "ex. São Paulo, SP",
    categoryLabel: "Categoria",
    jobTypeLabel: "Tipo de Vaga",
    experienceLabel: "Nível de Experiência",
    salaryMin: "Salário Mínimo (USD)",
    salaryMax: "Salário Máximo (USD)",
    descriptionLabel: "Descrição da Vaga",
    descriptionPlaceholder: "Descreva o cargo, responsabilidades e o candidato ideal...",
    requirementsLabel: "Requisitos",
    benefitsLabel: "Benefícios",
    externalLinkLabel: "Link Externo (opcional)",
    externalLinkPlaceholder: "https://empresa.com/vagas/aplicar",
    addRequirement: "+ Adicionar requisito",
    addBenefit: "+ Adicionar benefício",
    isRemote: "Esta é uma vaga remota",
    publish: "Publicar Anúncio",
    successMsg: "Vaga publicada! Redirecionando...",
    companyNameLabel: "Nome da Empresa",
    websiteLabel: "Site",
    industryLabel: "Setor",
    companySizeLabel: "Tamanho da Empresa",
    headquartersLabel: "Sede",
    logoUrlLabel: "URL do Logo",
    descriptionLabel2: "Descrição",
  },
  pipeline: {
    new_applicant: "Novo",
    contacted: "Contactado",
    interview: "Entrevista",
    offer: "Oferta",
    hired: "Contratado",
    rejected: "Rejeitado",
  },
  cvViewer: {
    loadError: "Não foi possível carregar o CV. Tente novamente.",
    noPreview: "Este arquivo não pode ser pré-visualizado. Baixe para abrir.",
    back: "Voltar",
    downloadPdf: "Baixar PDF",
  },
  notifyApplicant: {
    title: "Quer avisar {name}?",
    message: "Mensagem",
    date: "Data",
    time: "Horário",
    endTime: "Horário de término",
    endTimeOptional: "Horário de término (opcional)",
    timezone: "Fuso horário",
    notes: "Notas / instruções para o candidato",
    modality: "Modalidade",
    modality_in_person: "Presencial",
    modality_video: "Videochamada",
    modality_phone: "Telefônica",
    modality_other: "Outra",
    location: "Local",
    locationPlaceholder: "Endereço da entrevista",
    link: "Link da videochamada",
    contactName: "Pessoa de contato",
    contactRole: "Cargo do contato",
    contactRolePlaceholder: "Ex: Hiring Manager",
    skip: "Não avisar",
    send: "Enviar aviso",
    sendError: "Não foi possível enviar o aviso. Tente novamente.",
    sentToast: "Aviso enviado ao candidato",
    rescheduledMessage: "Os detalhes da sua entrevista foram atualizados. Confira a nova data e horário.",
    template: {
      contacted: "Olá {name}, vimos sua candidatura para {job} e gostaríamos de conversar.",
      interview: "Olá {name}, gostaríamos de convidá-lo(a) para uma entrevista para a vaga de {job}.",
      offer: "Olá {name}, temos uma oferta para você para a vaga de {job}!",
      hired: "Olá {name}, parabéns! Você foi selecionado(a) para a vaga de {job}.",
      rejected: "Olá {name}, obrigado pelo seu interesse em {job}. Decidimos seguir com outro candidato, mas valorizamos muito sua candidatura.",
    },
  },
  interviewForm: {
    sectionWhen: "QUANDO",
    sectionContact: "CONTATO",
    sectionMessage: "MENSAGEM PARA O CANDIDATO",
    messagePlaceholder: "Adicione informações extras para o candidato...",
    linkPlaceholder: "Google Meet, Zoom, Teams...",
    phonePlaceholder: "Número de contato",
    otherDetailsPlaceholder: "Descreva como será a entrevista",
    cancel: "Cancelar",
  },
  notificationsInbox: {
    bannerLabel: "Atualizações das suas candidaturas",
  },
  companyBilling: {
    title: "Plano e Faturamento",
    trialActive: "Teste gratuito",
    planActive: "Plano ativo",
    changePlan: "Trocar plano",
    price: "Preço",
    expiresAt: "Vencimento",
    accessUntil: "Acesso até",
    noExpiry: "Sem vencimento",
    listings: "Publicações",
    unlimited: "Ilimitadas",
    noActivePlan: "Você não tem um plano ativo no momento.",
    manageBilling: "Gerenciar faturamento",
    portalError: "Não foi possível abrir o portal de faturamento. Tente novamente.",
    paymentSuccessToast: "Pagamento confirmado! Seu plano está sendo ativado.",
    paymentCancelledToast: "Pagamento cancelado. Nenhuma cobrança foi feita.",
    pastDueWarning: "Há um problema com seu método de pagamento.",
    pastDueCta: "Atualizar método de pagamento",
    statusPastDue: "Pagamento pendente",
    statusCancelling: "Cancelamento agendado",
  },
  footer: {
    description: "O marketplace profissional de empregos que conecta candidatos e empresas: crie seu perfil profissional, prepare seu currículo, busque vagas e candidate-se a novas oportunidades.",
    network: "Rede InfoCity",
    seekersTitle: "Para Candidatos",
    employersTitle: "Para Empregadores",
    companyTitle: "InfoCity",
    browseJobs: "Buscar Vagas",
    companies: "Empresas",
    savedJobs: "Vagas Salvas",
    myApplications: "Minhas Candidaturas",
    exploreNearby: "Explorar vagas perto de mim",
    postJob: "Publicar Vaga",
    employerDash: "Painel do Empregador",
    hiringSolutions: "Soluções de Contratação",
    applicantTracking: "Rastreamento de Candidatos",
    aboutInfoCity: "Sobre InfoCity",
    privacy: "Política de Privacidade",
    terms: "Termos de Serviço",
    contact: "Contato",
    cookiePrefs: "Preferências de cookies",
    copyright: "InfoCity Ecosystem. Todos os direitos reservados.",
    partOf: "Parte do ecossistema de marketplaces",
  },
  legal: {
    backHome: "Voltar ao início",
    draftDisclaimer: "Este documento é um rascunho operacional e não constitui aconselhamento jurídico final.",
    contactTitle: "Contato",
    contactSubtitle: "Tem alguma dúvida sobre sua conta, seus dados ou estes Termos? Fale com a gente.",
    legalDataPending: "Os dados legais da entidade responsável (razão social, endereço, CNPJ/NIF) ainda estão pendentes.",
  },
  cookies: {
    bannerText: "Usamos cookies necessários para o funcionamento do site e, com seu consentimento, cookies de análise para melhorar a experiência.",
    learnMore: "Saiba mais",
    necessary: "Necessários (sempre ativos)",
    analytics: "Análise",
    preferences: "Preferências de cookies",
    savePreferences: "Salvar preferências",
    reject: "Rejeitar",
    accept: "Aceitar",
  },
  privacy: {
    title: "Privacidade e dados",
    exportData: "Baixar meus dados",
    exportDataHint: "Receba uma cópia em JSON das suas informações pessoais.",
    marketingEmails: "Novidades e oportunidades por e-mail",
    marketingEmailsHint: "Você pode desativar isso a qualquer momento. Não afeta e-mails transacionais.",
    changePasswordTitle: "Alterar senha",
    changePasswordHint: "Ao alterá-la, as sessões abertas em outros dispositivos serão encerradas.",
    currentPasswordLabel: "Senha atual",
    currentPasswordIncorrect: "A senha atual está incorreta.",
    changePasswordButton: "Atualizar senha",
    passwordChangedSuccess: "Sua senha foi atualizada. As demais sessões foram encerradas por segurança.",
    deleteAccount: "Excluir minha conta",
    deleteWarning: "Esta ação é irreversível. Seus dados pessoais, currículo e foto de perfil serão excluídos. Suas candidaturas serão mantidas anonimizadas como registro das empresas correspondentes.",
    deleteConfirmWord: "excluir",
    incorrectPassword: "A senha está incorreta.",
    deleteFailed: "Não foi possível excluir sua conta. Tente novamente.",
  },
  emailVerify: {
    title: "Verifique seu e-mail",
    body: "Enviamos um link de verificação. Você pode continuar usando o InfoCityJobs enquanto isso.",
    resend: "Reenviar e-mail",
    resendSuccess: "Enviamos um novo e-mail de verificação.",
    dismiss: "Agora não",
    verifyingTitle: "Verificando seu e-mail...",
    successTitle: "E-mail verificado!",
    successBody: "Sua conta foi confirmada com sucesso.",
    invalidLink: "Este link de verificação é inválido ou já foi utilizado.",
    expiredLink: "Este link de verificação expirou. Você pode solicitar um novo na sua conta.",
    goToApp: "Ir para o InfoCityJobs",
  },
  common: {
    cancel: "Cancelar",
    loading: "Carregando...",
  },
  ai: {
    title: "InfoCity IA",
    subtitle: "Assistente de Busca de Vagas",
    placeholder: "Pergunte sobre vagas...",
    initialMessage: "Olá! Sou o Assistente IA da InfoCity. Posso ajudá-lo a buscar vagas, preparar-se para entrevistas ou guiá-lo pela plataforma. O que você está procurando hoje?",
    suggestions: ["Buscar vagas de tech", "Como se candidatar?", "Dicas de currículo"],
    close: "Fechar",
    send: "Enviar",
    error: "Desculpe, estou com dificuldades. Por favor, tente novamente.",
    careerTitle: "Assistente de Carreira IA",
    careerSubtitle: "Orientação de carreira personalizada",
    careerGreeting: "Olá {name}! Sou seu Assistente de Carreira IA. Posso analisar seu CV, sugerir vagas compatíveis e ajudar você a avançar na carreira. O que gostaria de saber?",
    careerGreetingGeneric: "Olá! Sou seu Assistente de Carreira IA. Posso analisar seu CV, sugerir vagas compatíveis e ajudar você a avançar na carreira. O que gostaria de saber?",
    usingCvHint: "Usando seu perfil de CV para respostas personalizadas",
    usingCompanyHint: "Usando os dados da sua empresa para respostas personalizadas",
    switchToChat: "Mudar para chat geral",
    switchToCareer: "Mudar para modo carreira",
    careerModeBtn: "Carreira",
    chatModeBtn: "Chat",
    careerPlaceholder: "Pergunte sobre sua carreira...",
    careerSuggestions: ["Quais vagas combinam com meu perfil?", "Como posso melhorar meu CV?", "Ajude-me a me preparar para entrevistas"],
    // Copy adaptada por papel (candidate / employer / guest) — usado por AIChat.jsx
    subtitleCandidate: "Seu assistente de emprego",
    subtitleEmployer: "Assistente para empregadores",
    subtitleGuest: "Seu assistente da InfoCityJobs",
    greetingCandidate: "Olá {name}! Sou seu assistente de carreira da InfoCityJobs. Posso ajudar a encontrar oportunidades, melhorar seu perfil e CV, preparar entrevistas e gerenciar sua busca de emprego. Como posso ajudar?",
    greetingCandidateGeneric: "Olá! Sou seu assistente de carreira da InfoCityJobs. Posso ajudar a encontrar oportunidades, melhorar seu perfil e CV, preparar entrevistas e gerenciar sua busca de emprego. Como posso ajudar?",
    greetingEmployer: "Olá {name}! Sou seu assistente de contratação da InfoCityJobs. Posso ajudar a publicar melhores vagas, encontrar candidatos, revisar perfis, organizar entrevistas e gerenciar seus processos de seleção. O que você precisa?",
    greetingEmployerGeneric: "Olá! Sou seu assistente de contratação da InfoCityJobs. Posso ajudar a publicar melhores vagas, encontrar candidatos, revisar perfis, organizar entrevistas e gerenciar seus processos de seleção. O que você precisa?",
    greetingGuest: "Olá! Sou o assistente da InfoCityJobs. Posso ajudar a encontrar vagas, entender como a plataforma funciona ou explicar como publicar uma vaga.",
    suggestionsCandidate: ["Buscar vagas", "Melhorar meu CV", "Preparar entrevista", "Melhorar meu perfil"],
    suggestionsEmployer: ["Criar uma vaga", "Buscar candidatos", "Melhorar um anúncio", "Gerenciar entrevistas"],
    suggestionsGuest: ["Buscar vagas", "Sou candidato", "Sou empresa", "Como funciona a InfoCityJobs"],
    placeholderCandidate: "Pergunte sobre sua carreira...",
    placeholderEmployer: "Pergunte sobre sua contratação...",
    placeholderGuest: "Pergunte sobre a InfoCityJobs...",
    viewJobBtn: "Ver vaga",
    viewProfileBtn: "Ver perfil",
    saveBtn: "Salvar",
    unsaveBtn: "Remover",
    compatibleLabel: "compatível",
    resultsRemote: "Remoto",
  },
  ecosystem: {
    youAreHere: "Você está aqui",
    prop: "Imóveis",
    jobs: "Empregos",
    cars: "Carros",
    shop: "Compras",
    boat: "Náutico",
    travel: "Viagens",
  },
  errors: {
    emailTaken: "E-mail já cadastrado", invalidCredentials: "E-mail ou senha incorretos",
    notAuthenticated: "Não autenticado", onlyCandidates: "Apenas candidatos podem se candidatar",
    onlyEmployers: "Apenas empregadores podem publicar vagas", alreadyApplied: "Você já se candidatou a esta vaga",
    jobNotFound: "Vaga não encontrada", cvNotFound: "CV não encontrado",
    aiNotConfigured: "Serviço de IA indisponível", parseFailed: "Não foi possível analisar o CV. Tente formato DOCX.",
    sessionExpired: "Sessão expirada. Faça login novamente.", unknownError: "Ocorreu um erro inesperado. Tente novamente.",
    accountSuspended: "Sua conta foi suspensa. Contate o suporte para mais informações.",
    googleLoginFailed: "Não foi possível verificar sua conta do Google. Tente novamente.",
    googleEmailNotVerified: "Seu email do Google não está verificado. Verifique-o na sua conta do Google e tente novamente.",
    noFile: "Selecione um arquivo primeiro", fileTooLarge: "Arquivo muito grande",
    jobClosed: "Esta vaga não aceita mais candidaturas", cvVersionNotFound: "Essa versão do seu CV não existe mais",
  },
  company: {
    dashTitle: "Painel do Empregador", overviewLabel: "Visão Geral", pipelineTitle: "Pipeline de Contratação",
    funnel: "Funil de Recrutamento", hiringPipeline: "Pipeline de Contratação", activeJobs: "Vagas Ativas",
    totalApps: "Candidaturas", interviews: "Entrevistas", hired: "Contratados",
    recentActivity: "Atividade Recente", latestApps: "Últimas Candidaturas",
    activeListings: "Anúncios Ativos", viewAll: "Ver todos",
    noJobsYet: "Sem vagas publicadas ainda", postFirstJob: "Publique sua primeira vaga para começar",
    noApplicants: "Sem candidatos ainda", appsAppearHere: "Candidaturas aparecerão aqui",
    interviewScheduledTitle: "Entrevista agendada",
    editInterviewBtn: "Editar entrevista",
    editInterviewTitle: "Editar entrevista",
    scheduleInterviewTitle: "Agendar entrevista",
    scheduleInterviewBtn: "Agendar entrevista",
    saveInterviewChanges: "Salvar alterações",
    editCompany: "Editar Perfil", saveCompany: "Salvar Perfil", keepUpdated: "Mantenha seu perfil atualizado para atrair melhores candidatos.",
    companyName: "Nome da Empresa", website: "Site", industry: "Setor", size: "Tamanho da Empresa",
    hq: "Sede", address: "Endereço exato", addressPlaceholder: "Digite um endereço e escolha uma sugestão",
    addressHint: "Um endereço exato ativa o botão \"Como chegar\" no perfil público.",
    legalName: "Razão social", taxId: "NIF/CIF/EIN", phone: "Telefone",
    verificationNeedsReviewTitle: "Verificação em revisão",
    verificationNeedsReviewDesc: "Encontramos algo para revisar nos seus dados. Nossa equipe vai revisar; você pode continuar publicando vagas nesse período.",
    verificationPendingTitle: "Complete a verificação básica da sua empresa",
    verificationPendingDesc: "Adicione razão social, NIF/CIF/EIN e telefone para obter o selo de Verificação básica. É automático e nunca bloqueia a publicação de vagas.",
    verificationVerifiedDesc: "Formato e consistência validados automaticamente.",
    logoUrl: "URL do Logo", description: "Descrição",
    sizePlaceholder: "Selecione uma faixa", sizeHelp: "Quantidade aproximada de funcionários",
    size_1_10: "1–10 funcionários", size_11_50: "11–50 funcionários", size_51_200: "51–200 funcionários",
    size_201_500: "201–500 funcionários", size_501_1000: "501–1.000 funcionários", size_1000_plus: "Mais de 1.000 funcionários",
    changeLogo: "Trocar logo", removeLogo: "Remover logo", removeLogoConfirm: "Remover o logo da empresa?",
    saveLogo: "Salvar logo", logoInvalidType: "Formato inválido. Use JPEG, PNG ou WEBP.",
    logoTooLarge: "A imagem é muito grande (máx. 8MB).", logoSavedOk: "Logo atualizado", logoRemovedOk: "Logo removido",
    logoUploadError: "Não foi possível atualizar o logo. Tente novamente.",
    settings: "Configurações", viewJob: "Ver vaga", closeJob: "Fechar este anúncio?",
    applicants: "candidatos", views: "visualizações", postedOn: "Publicado",
    viewCv: "Ver CV", primaryCvSubmitted: "CV principal", adaptedCvSubmitted: "CV adaptado para esta vaga",
    postFirstJobBtn: "Publique sua Primeira Vaga",
    pauseTooltip: "Pausar vaga", resumeTooltip: "Reativar vaga", closeTooltip: "Fechar vaga", editTooltip: "Editar vaga",
    topMatchingCandidates: "Melhores Candidatos Compatíveis", allApplicantsTitle: "Todos os Candidatos",
    jobPositionLabel: "Cargo", allJobsOption: "Todas as Vagas",
    searchCandidatesLabel: "Buscar Candidatos", searchCandidatesPlaceholder: "Busque por nome, habilidade, palavra-chave...",
    rankedByAI: "Classificado por compatibilidade de IA",
    linkedinProfileLink: "Perfil do LinkedIn", profileLink: "Perfil", noCvUploaded: "Nenhum CV enviado",
    cancelBtn: "Cancelar",
    noCompanyProfileYet: "Você ainda não configurou o perfil da sua empresa. Clique em \"Editar Perfil\" para começar.",
    profileCompleteness: "Perfil {pct}% completo",
    foundedYear: "Ano de fundação",
    linkedinUrl: "LinkedIn",
    instagramUrl: "Instagram",
    culture: "Cultura e ambiente",
    culturePlaceholder: "Conte como é trabalhar na sua empresa...",
    benefits: "Benefícios",
    benefitsPlaceholder: "Um benefício por linha, ex: Horário flexível",
    benefitsHint: "Escreva um benefício por linha.",
    searchListingsPlaceholder: "Buscar por título...",
    filterAll: "Todos",
    sortNewest: "Mais recentes",
    sortOldest: "Mais antigos",
    sortApplicants: "Mais candidatos",
    noListingsMatch: "Nenhum anúncio corresponde a esses filtros.",
    postErrorGeneric: "Não foi possível publicar a vaga. Tente novamente.",
    editErrorGeneric: "Não foi possível atualizar a vaga. Tente novamente.",
    stageErrorGeneric: "Não foi possível atualizar o estágio do candidato. Tente novamente.",
    profileSaveError: "Não foi possível salvar o perfil da empresa. Tente novamente.",
    profileSavedOk: "Perfil salvo com sucesso", jobUpdatedOk: "Vaga atualizada com sucesso",
    stageUpdatedOk: "Estágio do candidato atualizado",
    locationNotVerifiedWarning: "Não conseguimos verificar essa localização no mapa. A vaga será publicada mesmo assim, mas verifique se o endereço está correto.",
    salaryRangeError: "O salário mínimo não pode ser maior que o salário máximo.",
    locationRequiredError: "Selecione o país e a cidade da vaga.",
    requirementPlaceholder: "Requisito",
    titlePlaceholder: "Ex: Engenheiro de Software Sênior", locationPlaceholder: "Ex: São Paulo, SP",
    descriptionPlaceholder: "Descreva a vaga, as responsabilidades e seu candidato ideal...",
    matchHigh: "Alta", matchMedium: "Média", matchLow: "Baixa",
    matchSuffix: "de compatibilidade",
    topCandidatesEyebrow: "Compatibilidade", topCandidatesTitle: "Melhores candidatos",
    noCandidatesYet: "Você ainda não tem candidatos para comparar.", forJobLabel: "Para:",
    kpiActiveJobs: "Vagas ativas", kpiNewCandidates: "Novos candidatos",
    kpiUpcomingInterviews: "Próximas entrevistas", kpiHires: "Contratações",
    kpiLast7Days: "Últimos 7 dias", kpiLast30Days: "Últimos 30 dias",
    interviewsEyebrow: "Agenda", upcomingInterviewsTitle: "Próximas entrevistas",
    interviewsUpcomingTab: "Próximas", interviewsHistoryTab: "Histórico",
    noUpcomingInterviews: "Você não tem entrevistas próximas.",
    noInterviewHistory: "Você ainda não tem entrevistas passadas.",
    viewCandidateBtn: "Ver candidato",
    stageFilterAll: "Todas", sortByLabel: "Ordenar por",
    sortRecent: "Mais recentes", sortMatchDesc: "Maior compatibilidade", sortMatchAsc: "Menor compatibilidade",
    viewMatchAnalysisBtn: "Ver por quê",
    viewInterviewDetailsBtn: "Ver detalhes",
    changeStageAria: "Mudar etapa",
    changeStageBtn: "Mudar etapa",
    candidateProfileAction: "Perfil",
    candidateMessageAction: "Mensagem",
    offerStatus_pending: "Oferta pendente",
    offerStatus_accepted: "Oferta aceita",
    offerStatus_rejected: "Oferta rejeitada",
    offerStatus_withdrawn: "Oferta retirada",
    offerWithdrawBtn: "Retirar oferta",
    offerWithdrawConfirm: "Retirar esta oferta?",
    offerWithdrawnOk: "Oferta retirada",
    confirmHireBtn: "Confirmar contratação",
    confirmHireMsg: "Confirmar a contratação de {name} para {job}?",
  },
  offerModal: {
    title: "Criar oferta de emprego",
    previewTitle: "Pré-visualização da oferta",
    previewSubtitle: "Revise os dados antes de enviar",
    jobTitle: "Cargo",
    workMode: "Modalidade",
    compMin: "Compensação",
    compMax: "Valor máximo",
    currency: "Moeda",
    period: "Período",
    period_hour: "por hora", period_day: "por dia", period_week: "por semana", period_month: "por mês", period_year: "por ano",
    compDetails: "Detalhes da compensação",
    compDetailsPlaceholder: "Ex: mais gorjetas, bônus por desempenho...",
    employmentType: "Tipo de contratação",
    schedule: "Horário / Jornada",
    startDate: "Data prevista de início",
    location: "Localização",
    additionalDetails: "Detalhes / condições adicionais",
    company: "Empresa",
    cancel: "Cancelar",
    continue: "Continuar",
    send: "Enviar oferta",
    sendError: "Não foi possível enviar a oferta. Tente novamente.",
    sentToast: "Oferta enviada",
  },
  offerDetail: {
    title: "Oferta recebida",
    status_accepted: "Oferta aceita",
    status_rejected: "Oferta rejeitada",
    status_withdrawn: "Esta oferta foi retirada pela empresa",
    accept: "Aceitar oferta",
    reject: "Rejeitar oferta",
    confirmAccept: "Confirma que deseja aceitar esta oferta de {company} para {job}?",
    confirmReject: "Confirma que deseja rejeitar esta oferta de {company} para {job}?",
    rejectReasonPrompt: "Motivo da rejeição (opcional)",
    actionError: "Não foi possível processar a ação. Tente novamente.",
  },
  categories: {
    Technology: "Tecnologia / TI", Finance: "Bancário / Finanças", Marketing: "Marketing / Publicidade", Design: "Design / Criatividade",
    Healthcare: "Medicina / Saúde", Education: "Educação", Sales: "Vendas / Comercial", Operations: "Operações",
    Product: "Produto", Legal: "Jurídico", Hospitality: "Hotelaria", Logistics: "Logística / Transporte",
    Administration: "Administração", CustomerService: "Atendimento ao Cliente", Construction: "Construção Civil",
    Accounting: "Contabilidade", FoodService: "Gastronomia / Restaurantes", Tourism: "Hotelaria / Turismo",
    Engineering: "Engenharia", SkilledTrades: "Ofícios / Manutenção", Manufacturing: "Produção / Manufatura",
    HumanResources: "Recursos Humanos", Retail: "Varejo / Comércio", Security: "Segurança", Services: "Serviços",
    Other: "Outros",
  },
  companyVisibility: {
    question: "Como você quer exibir a empresa nesta vaga?",
    showCompany: "Mostrar minha empresa",
    hideCompany: "Publicar como empresa confidencial",
    chooseDisplayLabel: "O que você quer mostrar no lugar?",
    previewTitle: "Assim sua vaga vai aparecer",
    hiddenNotice: "Seu nome real NÃO será visível publicamente nesta vaga.",
    presetOther: "Outra",
    presetOtherPlaceholder: "Escreva como você quer que apareça",
    presetOtherExample: "Ex: Importante empresa do setor hoteleiro",
    preset_important: "Importante empresa",
    preset_important_sector: "Importante empresa do setor de {sector}",
    preset_important_sector_generic: "Importante empresa do setor",
    preset_leader_sector: "Empresa líder do setor de {sector}",
    preset_leader_sector_generic: "Empresa líder do setor",
    preset_recognized: "Reconhecida empresa do setor de {sector}",
    preset_recognized_generic: "Reconhecida empresa",
    preset_international: "Empresa internacional",
    preset_multinational: "Multinacional",
    preset_growing: "Empresa em crescimento",
    preset_startup: "Startup em crescimento",
    preset_group: "Grupo empresarial",
    preset_consultancy: "Consultoria especializada",
  },
  companyAccess: {
    title: "Escolha o plano ideal para sua empresa",
    subtitle: "Publique suas vagas e comece a receber candidatos.",
    limitTitle: "Você atingiu o limite de publicações do seu plano",
    limitSubtitle: "Escolha outro plano com mais vagas incluídas ou aguarde sua próxima renovação.",
    noPlansAvailable: "Os planos para o seu país estarão disponíveis em breve. Contate a equipe da InfoCityJobs.",
    choosePlan: "Escolher plano",
    continueToPayment: "Continuar para o pagamento",
    startTrial: "Começar teste gratuito",
    days: "dias",
    listingsIncluded: "vagas incluídas",
    formPreservedNote: "Sua vaga foi salva exatamente como você deixou — nada foi perdido.",
    activatedToast: "Plano ativado. Agora você já pode publicar sua vaga.",
    trialStartedToast: "Período de teste iniciado. Agora você já pode publicar sua vaga.",
    alreadySubscribedNote: "Você já tem uma assinatura ativa. Gerencie seu plano, forma de pagamento ou cancelamento em Gerenciar Faturamento.",
    durationUnit: { day: "dia", week: "semana", month: "mês", year: "ano", unlimited: "sem vencimento" },
  },
  jobDetailExtra: {
    applyPosition: "Candidatar-se à Vaga", at: "em", fullNameReq: "Nome Completo *", emailReq: "E-mail *",
    phoneReq: "Telefone *", linkedinOpt: "LinkedIn (opcional)", uploadCV: "Enviar CV",
    uploadHint: "Clique para enviar PDF, DOC, DOCX", coverLetter: "Carta de Apresentação",
    coverHint: "Por que você é o candidato ideal?", submitApp: "Enviar Candidatura",
    successTitle: "Candidatura Enviada!", successMsg: "Boa sorte! A equipe entrará em contato.",
    continue: "Continuar Buscando", closeModal: "Fechar",
    selectCvTitle: "Com qual CV você quer se candidatar?", primaryCvLabel: "CV principal",
    recommendedBadge: "Recomendado para esta vaga", adaptCvSecondaryCta: "Adaptar meu CV para esta vaga",
    noCvTitle: "Você precisa de um CV para se candidatar", noCvDesc: "Crie seu CV profissional para poder enviar candidaturas.",
    createCvCta: "Criar meu CV", versionDeletedError: "Essa versão do seu CV não existe mais. Escolha outra opção.",
    usedCvLabel: "CV utilizado", viewApplicationsCta: "Ver minhas candidaturas",
  },
  profProfile: {
    back: "Voltar", openToWorkBadge: "✓ Disponível", summary: "Resumo Profissional",
    workExp: "Experiência Profissional", education: "Educação", skills: "Habilidades", languages: "Idiomas",
    certifications: "Certificações", portalCompat: "Compatibilidade de Portais", activeIn: "Ativo em",
    editProfile: "Editar Perfil", downloadCV: "Baixar CV", completeness: "Completude do Perfil",
    completePrompt: "Completar perfil →", present: "Atual",
  },
  lang: { es: "Español", en: "English", pt: "Português" },

  tabs: {
    recommended: "Recomendados", applications: "Candidaturas", savedJobs: "Vagas Salvas",
    myCV: "Meu CV", professionalProfile: "Perfil Profissional", overview: "Visão Geral",
    exploreNearby: "Explorar vagas perto de mim",
    postJob: "Publicar Vaga", myListings: "Minhas Vagas", applicants: "Candidatos", companyProfile: "Perfil da Empresa",
  },
  hiring: {
    pipelineTitle: "Pipeline de Contratação", pipelineFunnel: "Funil de Recrutamento",
    topCandidates: "Melhores Candidatos", allApplicants: "Todos os Candidatos",
    hiringProbability: "Probabilidade de Contratação",
    high: "Alta", medium: "Média", low: "Baixa", rankedByAI: "Ordenado por IA",
    filterByJob: "Vaga", allJobs: "Todas as vagas", searchCandidates: "Buscar Candidatos",
    searchPlaceholder: "Nome, habilidade, palavra-chave...", viewProfile: "Ver Perfil", viewCV: "Ver CV",
    noCV: "Sem CV enviado", coverLetter: "Carta de Apresentação",
  },
  cv: {
    builderTitle: "Criar CV", builderSubtitle: "Crie seu CV profissional com ajuda da IA em minutos",
    aiPowered: "Com IA", stepPersonal: "Dados Pessoais", stepSummary: "Resumo",
    stepExperience: "Experiência", stepEducation: "Educação", stepSkills: "Habilidades",
    stepLanguages: "Idiomas", stepPreview: "Pré-visualização", fullName: "Nome Completo",
    professionalTitle: "Título Profissional", yearsExp: "Anos de Experiência",
    titlePlaceholder: "ex. Engenheiro Sênior de Software",
    summaryHint: "Descreva sua trajetória e deixe a IA melhorar automaticamente.",
    generateAI: "Gerar com IA", aiImprove: "Melhorar com IA", suggestSkills: "Sugerir Habilidades com IA",
    uploadCVBtn: "Enviar PDF / DOCX", importCVHint: "Já tem um CV? Importar automaticamente",
    parsing: "Analisando...", parsedOK: "CV analisado e importado", parseFailed: "Falha ao analisar. Tente DOCX.",
    aiImproved: "IA melhorou seu texto!", addTextFirst: "Adicione algum texto primeiro",
    company: "Empresa", position: "Cargo", startDate: "Data início", endDate: "Data fim",
    currentJob: "Atual", responsibilities: "Responsabilidades", institution: "Instituição",
    degree: "Grau", field: "Área de estudo", year: "Ano",
    skillsHint: "Digite uma habilidade e pressione Enter", industriesHint: "ex. Tecnologia, Finanças...",
    languagesHint: "ex. Inglês (Nativo), Espanhol (B2)...", certHint: "ex. AWS, PMP...",
    industries: "Setores", addExperience: "+ Adicionar Experiência", addEducation: "+ Adicionar Educação",
    saveCV: "Salvar CV", saving: "Salvando...", saved: "CV salvo", downloadPDF: "Baixar PDF",
    downloadWord: "Baixar Word", goToDashboard: "Ir ao Painel", toDashboard: "Ver Painel",
    cvStrength: "Força do CV", cvScore: "Pontuação CV", suggestions: "Sugestões",
    previous: "Anterior", next: "Próximo", previewTitle: "Pré-visualização e Salvar",
    skillsFieldLabel: "Habilidades (pressione Enter para adicionar)", languagesFieldLabel: "Idiomas (pressione Enter para adicionar)",
    certFieldLabel: "Certificações (pressione Enter para adicionar)",
    certDetailHint: "Você pode adicionar organização, datas e credencial no seu Perfil Profissional.",
    summaryPlaceholder: "Engenheiro de software com mais de 5 anos construindo aplicações web escaláveis...",
    companyPlaceholder: "Ex: TechCorp Ltda.", positionPlaceholder: "Ex: Engenheiro Sênior",
    responsibilitiesPlaceholder: "Descreva suas principais responsabilidades e conquistas...",
    institutionPlaceholder: "Ex: Universidade Federal", degreePlaceholder: "Ex: Bacharelado", fieldPlaceholder: "Ex: Ciência da Computação",
    stepCounterPrefix: "Etapa", stepCounterOf: "de", viewStages: "Ver etapas",
    saveHint: "Pressione \"Salvar CV\" para finalizar e baixar seu currículo.",
  },
  bottomNav: {
    search: "Buscar", recommended: "Recomendados", applications: "Candidaturas", myJobs: "Minhas Vagas", messages: "Mensagens", whoViewedMe: "Quem me Viu", cv: "CV", profile: "Perfil", home: "Início",
    overview: "Resumo", listings: "Anúncios", post: "Publicar", applicants: "Candidatos", panel: "Meu Painel",
  },
  mobileHeader: { menu: "Menu", notifications: "Notificações", settings: "Configurações", myProfile: "Meu perfil", guestSubtitle: "Encontre sua próxima vaga", hiringCta: "Contratando?", sectionAccount: "Conta", sectionExplore: "Explorar", sectionHelp: "Ajuda", help: "Ajuda" },
  myJobs: {
    title: "Minhas Vagas",
    tabSaved: "Salvas", tabApplications: "Candidaturas", tabInterviews: "Entrevistas",
    savedEmptyTitle: "Você ainda não salvou nenhuma vaga",
    savedEmptyDesc: "Salve as vagas do seu interesse para encontrá-las facilmente aqui.",
    savedCta: "Buscar vagas",
    appsEmptyTitle: "Você ainda não tem candidaturas",
    appsEmptyDesc: "Quando você se candidatar a uma vaga, poderá acompanhar o status aqui.",
    interviewsEmptyTitle: "Nenhuma entrevista agendada",
    interviewsEmptyDesc: "Quando uma empresa agendar uma entrevista, ela aparecerá aqui.",
    interviewsUpcomingTab: "Próximas", interviewsHistoryTab: "Histórico",
    interviewsHistoryEmptyTitle: "Você ainda não tem entrevistas passadas",
    interviewsHistoryEmptyDesc: "As entrevistas que já aconteceram aparecerão aqui.",
    interviewLabel: "Entrevista",
    withLabel: "Com",
    addToCalendar: "Adicionar ao calendário",
    calendarPositionLabel: "Entrevista para",
    calendarCompanyLabel: "Empresa",
    calendarContactRoleLabel: "Cargo do contato",
    calendarModalityLabel: "Modalidade",
    calendarLinkLabel: "Link da entrevista",
    calendarNotesLabel: "Notas",
    calendarFooter: "Criado a partir do InfoCityJobs",
  },
  calendarSheet: {
    title: "Adicionar ao calendário",
    googleTitle: "Google Agenda",
    googleSubtitle: "Adicionar com o Google Agenda",
    appleTitle: "Calendário da Apple",
    appleSubtitle: "Adicionar ao calendário do iPhone, iPad ou Mac",
    cancel: "Cancelar",
  },
  whoViewedMe: {
    title: "Quem me Viu",
    emptyTitle: "Ainda não há visitas recentes",
    emptyDesc: "Quando uma empresa encontrar ou visitar seu perfil, aparecerá aqui.",
    cta: "Melhorar meu perfil",
    relatedTo: "Relacionado a",
  },
  profileHub: {
    companiesCanFindYou: "As empresas podem encontrar você",
    onlyAppliedCompaniesCanSeeYou: "Só as empresas onde você se candidatou podem te ver",
    visibilitySaveError: "Não foi possível salvar, tente novamente.",
    visibilityOnTitle: "Perfil visível",
    visibilityOnDesc: "Todas as empresas cadastradas podem encontrar e consultar seu perfil profissional.",
    visibilityOffTitle: "Perfil privado",
    visibilityOffDesc: "Seu perfil não aparece em buscas, Talent Pool, recomendações nem na descoberta de candidatos. Só as empresas onde você se candidatou podem vê-lo.",
    rowProfessionalProfile: "Perfil profissional",
    rowCV: "CV",
    rowContact: "Informações de contato",
    rowCountryLanguage: "País e idioma",
    rowSettings: "Configurações",
    rowAccount: "Conta",
    rowPrivacy: "Privacidade",
    rowHelp: "Ajuda",
    logout: "Sair",
  },
  settingsHub: {
    back: "Voltar",
    soundLabel: "Som das mensagens",
    soundHint: "Reproduz um som quando chega uma nova mensagem.",
  },
  contact: { postalCodeLabel: "CEP", postalCodePrivate: "Visível somente para você" },
  countryLanguage: { countryLabel: "País", languageLabel: "Idioma" },
  messages: {
    title: "Mensagens",
    emptyTitle: "Você ainda não tem mensagens",
    emptyDesc: "Quando uma empresa entrar em contato, as mensagens aparecerão aqui.",
    selectConversation: "Selecione uma conversa",
    messagePlaceholder: "Escreva uma mensagem…",
    send: "Enviar",
    sendMessage: "Enviar mensagem",
    sendError: "Não foi possível enviar sua mensagem. Tente novamente.",
    pushBannerText: "Ative as notificações para não perder novas mensagens, mesmo com o InfoCityJobs fechado.",
    pushBannerEnable: "Ativar notificações",
    soundOnTooltip: "Som ativado — clique para silenciar",
    soundOffTooltip: "Som silenciado — clique para ativar",
    typingIndicator: "Digitando…",
    deleteConversationConfirm: "Excluir esta conversa? Ela só será removida da sua caixa de entrada — a outra parte ainda a verá.",
    deleteConversationTooltip: "Excluir conversa",
  },

  notifOnboarding: {
    title: "Ative as notificações",
    body: "Receba mensagens, entrevistas e novidades importantes mesmo com o InfoCityJobs fechado.",
    activate: "Ativar notificações",
    notNow: "Agora não",
  },
  profile: {
    universal: "Perfil Profissional Universal InfoCity", myProfile: "Perfil",
    editProfile: "Editar Perfil", viewPublic: "Como as empresas me veem",
    completeness: "Completude do Perfil", completeProfile: "Completar perfil →",
    about: "Sobre", career: "Carreira", academic: "Acadêmico", workExp: "Experiência Profissional",
    portalCompat: "Compatibilidade de Portais", activeIn: "Ativo em",
    openToWork: "Disponível para trabalho", openToWorkDesc: "Permita que empresas descubram seu perfil no Talent Pool",
    openToWorkActive: "Seu perfil é visível para empresas no Talent Pool",
    addTitle: "Adicione seu título", addLocation: "Adicione localização", addExperience: "Adicione experiência",
    yearsExp: "anos de experiência", present: "Atual",
  },

  /* ── Professional Profile tab (Meu Perfil Profissional) ── */
  profTab: {
    unnamedCandidate:   "Candidato(a)",
    availableStatus:    "Disponível para novas oportunidades",
    notAvailableStatus: "Não disponível atualmente",
    privacyHint:        "Ao ativar \"Disponível para trabalho\", seu perfil e informações profissionais ficarão visíveis para empresas da plataforma.",
    completeProfileCta: "Completar perfil",
    completeCtaBasic_info: "Completar dados básicos",
    completeCtaSummary: "Adicionar resumo",
    completeCtaExperience: "Adicionar experiência",
    completeCtaEducation: "Adicionar formação",
    completeCtaSkills: "Adicionar habilidades",
    completeCtaLanguages: "Adicionar idiomas",
    completeCtaIndustries: "Adicionar indústria",
    completeCtaPreferences: "Adicionar preferências de trabalho",
    completeCtaCv_document: "Gerar seu currículo",
    completeCtaPhoto: "Adicionar foto",
    save: "Salvar", cancel: "Cancelar", delete: "Excluir", saving: "Salvando...",

    basicInfoTitle: "Dados básicos",
    nameLabel: "Nome completo",
    titleFieldLabel: "Título profissional",
    titleFieldPlaceholder: "Ex: Técnico de Telecomunicações",
    locationFieldLabel: "Localização",
    phoneFieldLabel: "Telefone",
    linkedinFieldLabel: "LinkedIn",

    aboutTitle: "Sobre mim",
    summaryEmpty: "Conte sobre sua trajetória profissional para as empresas te conhecerem melhor.",
    addSummaryBtn: "Adicionar resumo",
    editSummaryBtn: "Editar resumo",
    improveWithAI: "Melhorar com IA",
    summaryPlaceholder: "Descreva sua experiência, pontos fortes e objetivos profissionais...",

    experienceTitle: "Experiência profissional",
    experienceEmpty: "Você ainda não adicionou experiência.",
    addExperienceBtn: "Adicionar experiência",
    editExperienceTitle: "Editar experiência",
    addExperienceTitle: "Adicionar experiência",
    deleteExperienceConfirm: "Excluir esta experiência?",
    positionLabel: "Cargo",
    companyLabel: "Empresa",
    startDateLabel: "Data de início",
    endDateLabel: "Data de fim",
    currentJobLabel: "Trabalho atual aqui",
    experienceLocationLabel: "Localização (opcional)",
    descriptionLabel: "Descrição",

    educationTitle: "Educação",
    educationEmpty: "Você ainda não adicionou educação.",
    addEducationBtn: "Adicionar educação",
    editEducationTitle: "Editar educação",
    addEducationTitle: "Adicionar educação",
    deleteEducationConfirm: "Excluir esta educação?",
    institutionLabel: "Instituição de ensino",
    degreeLabel: "Título",
    fieldLabel: "Área de estudo",
    yearLabel: "Ano",

    skillsEmpty: "Adicione suas habilidades para se destacar nas buscas.",
    addSkillBtn: "Adicionar habilidade",
    editSkillsTitle: "Editar habilidades",
    skillsHint: "Digite uma habilidade e pressione Enter",
    showAllSkills: "Ver todas ({count})",
    showLessSkills: "Ver menos",

    languagesEmpty: "Adicione os idiomas que você fala.",
    addLanguageBtn: "Adicionar idioma",
    editLanguagesTitle: "Editar idiomas",
    languageNamePlaceholder: "Idioma (ex. Inglês)",
    languageLevelLabel: "Nível",
    levelNative: "Nativo",
    levelAdvanced: "Avançado (C1)",
    levelIntermediate: "Intermediário (B2)",
    levelBasic: "Básico (A2)",
    addLanguageAction: "Adicionar",

    preferencesTitle: "Preferências profissionais",
    preferencesEmpty: "Conte que tipo de emprego você procura para melhorar suas recomendações.",
    addPreferencesBtn: "Adicionar preferências",
    editPreferencesTitle: "Preferências profissionais",
    desiredPositionsLabel: "Cargos desejados",
    desiredPositionsHint: "Digite um cargo e pressione Enter",
    desiredCategoriesLabel: "Categorias profissionais",
    desiredLocationsLabel: "Localizações desejadas",
    desiredLocationsHint: "Digite uma localização e pressione Enter",
    preferredModalityLabel: "Modalidade",
    preferredShiftLabel: "Tipo de jornada",
    preferredContractLabel: "Tipo de contrato",
    availabilityLabel: "Disponibilidade",
    availabilityImmediate: "Imediata",
    availability2Weeks: "Em 2 semanas",
    availability1Month: "Em 1 mês",
    availabilityNegotiable: "A combinar",
    salaryMinExpectationLabel: "Salário mínimo desejado",
    willingToRelocateLabel: "Disponibilidade para mudar de residência",
    willingToTravelLabel: "Disponibilidade para viajar",

    cvDocTitle: "CV e documentos",
    cvDocUpdated: "Atualizado",
    cvDocEmpty: "Você ainda não criou seu CV.",
    cvDocCreateBtn: "Criar meu CV",
    viewCvBtn: "Ver CV",

    missingHintBasic_info: "Complete seus dados básicos para as empresas te encontrarem.",
    missingHintSummary: "Adicione um resumo profissional para se destacar.",
    missingHintExperience: "Adicione sua experiência profissional para melhorar suas candidaturas.",
    missingHintEducation: "Adicione sua educação para completar seu perfil.",
    missingHintSkills: "Adicione pelo menos 3 habilidades para aparecer em mais buscas.",
    missingHintLanguages: "Adicione os idiomas que você fala.",
    missingHintIndustries: "Adicione pelo menos um setor para melhorar suas recomendações.",
    missingHintPreferences: "Adicione suas preferências profissionais para melhorar suas recomendações.",
    missingHintCv_document: "Gere seu CV para poder se candidatar a vagas.",
    missingHintPhoto: "Adicione uma foto de perfil para causar uma melhor primeira impressão.",

    avatarTitle: "Foto de perfil",
    cropAvatarTitle: "Ajuste sua foto",
    changePhotoBtn: "Alterar foto",
    deleteAvatarConfirm: "Excluir sua foto de perfil?",
    avatarInvalidType: "Formato inválido. Use JPEG, PNG ou WEBP.",
    avatarTooLarge: "A imagem é muito grande (máx. 8MB).",

    companyViewCta: "Como as empresas me veem",
    companyPreviewNote: "Esta é uma pré-visualização de como seu perfil profissional pode ser apresentado às empresas.",
    backToEditProfile: "Voltar a editar perfil",

    industriesTitle: "Setores",
    industriesEmpty: "Você ainda não adicionou nenhum setor.",
    addIndustryBtn: "Adicionar setor",
    editIndustriesTitle: "Editar setores",
    industriesHint: "Digite um setor e pressione Enter",

    certificationsTitle: "Certificações",
    certificationsEmpty: "Você ainda não adicionou nenhuma certificação.",
    addCertificationBtn: "Adicionar certificação",
    editCertificationTitle: "Editar certificação",
    addCertificationTitle: "Adicionar certificação",
    deleteCertificationConfirm: "Excluir esta certificação?",
    certNameLabel: "Nome da certificação",
    certNameRequired: "Digite o nome da certificação.",
    certIssuerLabel: "Organização emissora",
    certIssueDateLabel: "Data de obtenção",
    certExpiryDateLabel: "Data de validade",
    certNoExpiryLabel: "Não expira",
    certCredentialIdLabel: "ID da credencial (opcional)",
    certCredentialUrlLabel: "URL da credencial (opcional)",
    certInvalidUrl: "A URL da credencial não é válida.",
    viewCredentialLink: "Ver credencial",

    savedSuccess: "Perfil atualizado",
  },
  homeSections: {
    cvTitle: "Seu CV", cvSubtitle: "Complete seu perfil e melhore suas candidaturas.",
    cvComplete: "completo", cvStateIncomplete: "Complete seu perfil", createMyCV: "Criar CV", continueCV: "Continuar CV", viewEditCV: "Ver ou editar CV",
    hiringQuestion: "Contratando?", postJobLink: "Publicar vaga",
    uploadMyCV: "Enviar meu CV",
    freeCVBuilder: "CV Gratuito", freeCVDesc: "Sem custo, sem cartão",
    aiImprovements: "Melhorias com IA", aiImprovDesc: "Descrições aprimoradas automaticamente",
    downloadPDF: "Baixar PDF", downloadPDFDesc: "Formato profissional pronto",
    talentLabel: "Talent Pool", talentTitle: "Descubra os melhores talentos",
    talentSubtitle: "Explore profissionais disponíveis e encontre o candidato ideal para sua empresa.",
    talentFilters: "Filtros", talentLocation: "Localização", talentSkills: "Habilidades",
    talentIndustry: "Setor", talentMinExp: "Exp. mínima", talentAnyExp: "Qualquer",
    talentApply: "Aplicar", talentClear: "Limpar",
    talentNoResults: "Nenhum candidato encontrado", talentNoResultsDesc: "Candidatos aparecem aqui quando ativam \"Disponível para trabalho\"",
    talentBrowseAll: "Ver todos os talentos", talentViewProfile: "Ver Perfil",
    talentYearsExp: "a exp", talentFresher: "Sem experiência",
    talentShowing: "Mostrando", talentOf: "de", talentCandidates: "candidatos",
    quickPostLabel: "Para Empregadores", quickPostTitle: "Publique uma vaga em 60 segundos",
    quickPostSubtitle: "Alcance milhares de candidatos qualificados e encontre o talento certo mais rápido.",
    quickPostFree: "Publicação gratuita", quickPostInstant: "Visibilidade imediata", quickPostAI: "Matching com IA",
    quickPostBtn: "Publicar Vaga", quickPostTitle2: "Título da vaga (ex. Desenvolvedor Frontend)",
    quickPostLocation: "Cidade ou localização (ex. São Paulo)", quickPostCompany: "Nome da empresa",
    signUpCandidate: "Cadastre-se como candidato →",
  },
  postJobLabels: {
    newListing: "Novo Anúncio", postJobTitle: "Publicar Vaga", jobTitleLabel: "Título da Vaga",
    locationLabel: "Localização", currentLocationLabel: "Localização atual", categoryLabel: "Categoria", jobTypeLabel: "Tipo de Vaga",
    experienceLabel: "Nível de Experiência", salaryMinLabel: "Salário Mínimo", salaryMaxLabel: "Salário Máximo",
    categoryOtherPlaceholder: "Digite a categoria", jobTypeOtherPlaceholder: "Digite o tipo de vaga", experienceOtherPlaceholder: "Digite o nível de experiência",
    descriptionLabel: "Descrição da Vaga", requirementsLabel: "Requisitos", benefitsLabel: "Benefícios",
    externalLinkLabel: "Link Externo (opcional)", isRemote: "Esta é uma vaga remota",
    urgencyLabel: "Imediatismo", urgencyNormal: "Vaga normal", urgencyToday: "Preciso cobrir hoje",
    urgencyUrgent: "Urgente", shiftLabelPlaceholder: "Turno/horário (opcional, ex. Tarde 16-22h)",
    addRequirement: "+ Adicionar requisito", addBenefit: "+ Adicionar benefício", publishBtn: "Publicar Anúncio",
    successMsg: "Vaga publicada! Redirecionando...", remotePosition: "Posição remota",
    management: "Gestão", listings: "Anúncios Ativos", newJob: "Nova Vaga",
    viewJob: "Ver vaga", applicants: "candidatos", views: "visualizações", posted: "Publicado", closeJob: "Fechar este anúncio?",
    active: "Ativo", paused: "Pausado", closed: "Fechado",
    editJobTitle: "Editar Vaga", updateBtn: "Salvar Alterações", cancelEditBtn: "Cancelar Edição",
    // Sprint: melhoria de Publicar Vaga (salário, modalidade, urgência, aplicação, IA, preview)
    salaryPeriodLabel: "Período do salário",
    periodHour: "Por hora", periodMonth: "Por mês", periodYear: "Por ano",
    hideSalaryLabel: "Não mostrar salário",
    workModeLabel: "Modalidade",
    workModeOnsite: "Presencial", workModeHybrid: "Híbrido", workModeRemote: "Remoto",
    remoteCountriesLabel: "De quais países o candidato pode trabalhar?",
    addressLabel: "Endereço exato (opcional)",
    addressPlaceholder: "Rua e número, ex: Rua Colombo 15",
    addressHint: "Usado apenas para posicionar o pino no mapa com precisão — não aparece publicamente no anúncio.",
    urgencyImmediate: "Início imediato",
    applicationMethodLabel: "Como você vai receber as candidaturas?",
    applyMethodInternal: "Receber candidaturas na InfoCityJobs",
    applyMethodExternal: "Redirecionar para um site externo",
    externalLinkInvalid: "Digite uma URL válida (deve começar com http:// ou https://)",
    improveWithAI: "✨ Melhorar com IA",
    improvingWithAI: "Melhorando com IA...",
    aiImproveModalTitle: "Proposta melhorada com IA",
    aiImproveOriginal: "Seu texto original",
    aiImproveProposal: "Proposta da IA",
    aiImproveAccept: "Usar esta versão",
    aiImproveCancel: "Cancelar",
    aiImproveError: "Não foi possível melhorar a descrição. Tente novamente.",
    aiImproveEmptyError: "Escreva uma descrição antes de melhorá-la com IA.",
    previewBtn: "Pré-visualizar",
    backToEditBtn: "Voltar a editar",
    publishFinalBtn: "Publicar vaga",
    saveChangesFinalBtn: "Salvar alterações",
    previewSectionTitle: "É assim que o candidato verá seu anúncio",
    confidentialCompanyLabel: "Empresa confidencial",
    previewSalaryHidden: "Salário não visível para candidatos",
  },
  geo: {
    countryLabel: "País",
    countryPlaceholder: "Selecione um país",
    cityLabel: "Cidade / Localidade",
    cityPlaceholder: "Comece a digitar para buscar...",
    cityNoResults: "Nenhuma correspondência encontrada. Você ainda pode digitar o local manualmente.",
    cityHint: "Selecione uma sugestão para verificar o local no mapa.",
    currencyLabel: "Moeda",
    currencyPlaceholder: "Selecione uma moeda",
    locationVerifiedBadge: "Local verificado",
    locationUnverifiedBadge: "Não verificado no mapa",
    admin1LabelByKey: {
      comunidadAutonoma: "Comunidade Autônoma", departamento: "Departamento",
      estado: "Estado", provincia: "Província",
    },
    admin1PlaceholderByKey: {
      comunidadAutonoma: "Selecione uma comunidade autônoma", departamento: "Selecione um departamento",
      estado: "Selecione um estado", provincia: "Selecione uma província",
    },
    admin2Label: "Província",
    admin2Placeholder: "Selecione uma província",
    anyCountry: "Qualquer país",
    anyRegion: "Qualquer região",
    anyProvince: "Qualquer província",
    done: "Concluído",
    countryNames: { ES: "Espanha", UY: "Uruguai", US: "Estados Unidos", AR: "Argentina", BR: "Brasil" },
    currencyNames: { EUR: "Euro", USD: "Dólar americano", UYU: "Peso uruguaio", ARS: "Peso argentino", BRL: "Real brasileiro" },
  },
};

export default pt;

pt.common = { close: "Fechar", seeAll: "Ver tudo" };
pt.share = { intro: "Confira esta vaga no InfoCityJobs:", linkCopied: "Link copiado" };
pt.cvSuggestions = {
  add_summary: "Adicione ou amplie seu resumo profissional",
  add_more_experience: "Adicione mais experiências profissionais",
  add_experience: "Adicione pelo menos uma experiência profissional",
  add_more_skills: "Adicione mais habilidades relevantes (mínimo 6)",
  add_skills: "Adicione habilidades técnicas e comportamentais",
  add_education: "Adicione sua formação acadêmica",
  add_linkedin: "Adicione seu perfil do LinkedIn",
  add_languages: "Adicione os idiomas que você fala",
  add_certifications: "Adicione certificações profissionais",
};
